export default {
  typography: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 800,
  },
  palette: {
    primary: {
      light: '#4355a1',
      main: '#002d72',
      dark: '#000346',
      contrastText: '#fff',
    },
    accent: {
      light: '#ff6973',
      main: '#da3248',
      dark: '#a10021',
      contrastText: '#000',
    },
  },
}
